import React from 'react';
import Svg from '../Svg';

const IconClockPlus = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C12.3928 21 12.7792 20.9749 13.1578 20.9263C13.7056 20.8561 14.2066 21.2432 14.2769 21.791C14.3472 22.3388 13.9601 22.8398 13.4123 22.9101C12.9495 22.9694 12.4781 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 12.4705 22.9704 12.9345 22.9129 13.3902C22.8437 13.9382 22.3435 14.3263 21.7955 14.2571C21.2476 14.188 20.8595 13.6877 20.9286 13.1398C20.9757 12.7669 21 12.3865 21 12C21 7.02944 16.9706 3 12 3ZM12 5C12.5523 5 13 5.44772 13 6V11.382L16.1856 12.9748C16.6796 13.2217 16.8798 13.8224 16.6328 14.3164C16.3858 14.8104 15.7851 15.0106 15.2912 14.7636L11.5528 12.8944C11.214 12.725 11 12.3788 11 12V6C11 5.44772 11.4477 5 12 5ZM19 15C19.5523 15 20 15.4477 20 16V18H22C22.5523 18 23 18.4477 23 19C23 19.5523 22.5523 20 22 20H20V22C20 22.5523 19.5523 23 19 23C18.4477 23 18 22.5523 18 22V20H16C15.4477 20 15 19.5523 15 19C15 18.4477 15.4477 18 16 18H18V16C18 15.4477 18.4477 15 19 15Z"
    />
  </Svg>
);

export default IconClockPlus;
